import LoginPageToRender from 'components/PageRenderer';
import React from 'react';

import { Box, designTokens, Flex } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import Links from '../../components/Links';
import backgroundVideo from '../../resources/Movement_Login_Video.mp4';
import movementLogo from '../../resources/Movement_Logo.svg';

import {
  BackgroundVideoWrapper,
  LoginFormWrapper,
  LoginPageWrapper,
  LoginWrapper,
} from './styles';

export const Root = () => {
  const { t } = useTranslation();

  return (
    <Flex css={LoginPageWrapper}>
      <Flex align="center" justify="center" gap="small" css={LoginWrapper}>
        <Box css={LoginFormWrapper}>
          <Box
            css={{
              textAlign: 'center',
              minHeight: '121px',
              minWidth: '230px',
              marginBottom: designTokens.spaceXLarge,
            }}
          >
            <img
              src={movementLogo}
              data-testid="logo"
              alt={t('loginPage.logoAltDescription')}
            />
          </Box>
          <LoginPageToRender />
        </Box>
        <Links />
      </Flex>
      <Flex css={BackgroundVideoWrapper}>
        <video autoPlay muted loop disablePictureInPicture>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      </Flex>
    </Flex>
  );
};
